/* 
.resume_timeline .timeline_content .timeline_title {
    font-size: 16px;
    font-weight: 500;
}

.resume_timeline .timeline_content .timeline_date {
    color: darkslategray;
}

.resume_timeline .timeline_content .timeline_description {
    color: gray;
    font-size: small;
    margin-top: 6px;
}

.skill {
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0px 0px 48px 0px rgba(4, 6, 4, 0.08);
    height: 80%;
}

.skill .skill_title {
    font-size: 14px;
    font-weight: 500;
    line-height: 35px;
}

.skill .skill_description {
    display: flex;
    align-items: center;
    color: #989898;
    font-weight: 400;
    line-height: 18px;
}

.skill .skill_description .timeline_dot {
    border-color: var(--main-color);
    padding: 2px;
    margin-right: 5px;
}   


 */

import { makeStyles } from "@material-ui/core";


const useStyles = makeStyles (theme => ({
  root: {
    backgroundColor: "#2d3748",
    color : "#808d9f"
  },
  section: {
    marginBottom: 40
  },
  sectionTitle: {
    position: 'relative',
    padding: '0 3px',
    marginBottom: 20,
    display: 'inline-block',
  },
  span: {
    position: 'absolute',
    height: 7,
    width: '100%',
    bottom: 0,
    opacity: 0.2,
    left: 0,
    backgroundColor: '#bdbdbd',
  },
  sectionTitleText: {
    fontSize: 20,
    fontWeight: 600,
    position: 'relative',
    margin: 0,
  },
  

  timelineTitle: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: 16,
    fontWeight: 500
  },
  timelineDate: {
    fontFamily: "'Roboto Slab', serif",
    color: "#bdbdbd",
    fontStyle: "bold"
  },
  timelineDescription: {
    fontFamily: "'Roboto Slab', serif",
    color: "#bdbdbd",
    fontSize: "small",
    marginTop: 6
  },
  education: {
    [theme.breakpoints.down("xs")]: {
      marginTop: 30,
    },
  },
  

  /* Service Section */
  serviceSection: {
    marginTop: 40,
    height: "100%",
    textAlign: "center"
  },
  service: {
    marginTop: 20
  },
  serviceTitle: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center"
  },
  serviceDescription: {
    fontFamily: "'Roboto Slab', serif",
    color: '#bdbdbd',
    marginRight: 5,
    textAlign: 'center',
  },

}));

export default useStyles;
